import { Component, OnInit } from '@angular/core';
import { TicketService, Ticket } from '../../services/ticket.service';
import { CondominiumService } from '../../services/condominium.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-tickets-summary',
    templateUrl: './tickets-summary.component.html',
    styleUrls: ['./tickets-summary.component.sass'],
    standalone: false
})
export class TicketsSummaryComponent implements OnInit {
  tickets: Ticket[] = [];
  isLoading = true;
  condominiumId: number | null = null;

  constructor(
    private ticketService: TicketService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        this.loadTickets();
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
  }

  private loadTickets(): void {
    if (!this.condominiumId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.ticketService.getTickets(this.condominiumId, 0, 5).subscribe({
      next: (response) => {
        this.tickets = response._embedded?.getTicketList || [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tickets:', error);
        this.isLoading = false;
      }
    });
  }

  getStatusTranslation(status: string): string {
    const translations: { [key: string]: string } = {
      'OPEN': 'Aberto',
      'IN_PROGRESS': 'Em andamento',
      'CLOSED': 'Fechado'
    };
    return translations[status] || status;
  }

  navigateToTicket(id: number): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/ticket`, id]);
    }
  }

  navigateToAllTickets(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/tickets`]);
    }
  }

  navigateToCreateTicket(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/ticket/create`]);
    }
  }
}
